<div class="container-fluid p-0 m-0" style="height: 80vh !important">
  <div class="card border-0 p-0 m-0">
    <div class="card-header">
      <span
        (click)="closeDialog()"
        class="material-symbols-outlined float-right text-white"
      >
        close
      </span>
      <span style="font-size: 20px" class="text-uppercase">My Bets</span>
    </div>

    <div class="card-body p-1 overflow-auto">
      <h3>Matched Bets</h3>
      <div class="my-market-container">
        <!-- <mat-tab-group>
          <mat-tab label="textdata"> cotains goes here</mat-tab>
        </mat-tab-group> -->
        <mat-tab-group>
          <mat-tab
            *ngFor="let key of tabKeys"
            [label]="key + ' (' + data[key].length + ')'"
          >
            <ng-container *ngIf="data[key].length > 0">
              <table style="width: 100%; border-collapse: collapse">
                <tbody>
                  <tr
                    *ngFor="let item of data[key]"
                    [class.lay-border]="item.type == 'Lay'"
                    [class.back-border]="item.type == 'Back'"
                  >
                    <td style="padding: 8px">
                      {{ item.runner_name }}
                    </td>
                    <td style="padding: 8px">
                      {{ item.price }}
                    </td>
                    <td style="padding: 8px">
                      {{ item.bet_amount }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
            <p *ngIf="data[key].length === 0">No data available</p>
          </mat-tab>
        </mat-tab-group>
      </div>
      <!-- <table class="table table-sm table-striped table-hover">
        <thead>
          <tr>
            <th>.</th>
            <th>Sub Type</th>
            <th>Type</th>
            <th>Event Name</th>
            <th>Runner</th>
            <th>Bet Amount</th>
            <th>Runs</th>
            <th>Rate</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody *ngIf="marge_bets.length > 0; else noResult">
          <tr *ngFor="let bet of marge_bets">
            <td>
              <i
                class="menu-icons mr-7 d-icon {{ bet.type | lowercase }} {{
                  bet.matchtype
                }}"
              ></i>
            </td>
            <td>{{ bet.main_type == "fancy" ? "toss" : bet.main_type }}</td>
            <td>{{ bet.type }}</td>
            <td
              routerLink="/dashboard/{{
                bet.sport == 'cricket'
                  ? 'match-details'
                  : bet.sport + '-details'
              }}/{{ bet.event_id }}"
              (click)="closeDialog()"
            >
              {{ bet.event_name }}
            </td>
            <td>{{ bet.runner_name }}</td>
            <td>Rs {{ bet.bet_amount }}</td>
            <td>{{ bet.main_type == "session" ? bet.price : "--" }}</td>
            <td>{{ bet.main_type == "session" ? bet.size : bet.price }}</td>
            <td>
              <span
                class="badge"
                [class.badge-success]="bet.status == 1"
                [class.badge-danger]="bet.status == 0"
                >{{ bet.status == "1" ? "OPEN" : "CLOSE" }}</span
              >
            </td>
            <td>{{ bet.updated_at | date : "MMM d, y h:mm a" }}</td>
          </tr>
        </tbody>
        <ng-template #noResult>
          <tbody>
            <tr>
              <td colspan="100">No data found</td>
            </tr>
          </tbody>
        </ng-template>
      </table> -->
    </div>
  </div>
</div>
